<template>
  <b-taginput
    :data="allowedFormats"
    :placeholder="$t('compSuperadminSettingsTravelFilesFormats.label')"
    v-model="buffer"
    :open-on-focus="true"
    @input="$emit('input', buffer)"
    rounded
    icon="caret-right"
  />
</template>

<script>
import { useCoreStore } from '@/stores/core.js'

export default {
  name: 'TravelFilesFormats',
  inject: ['$validator'],
  props: {
    value: Array
  },
  setup () {
    const coreStore = useCoreStore()
    return { coreStore }
  },
  data () {
    return {
      buffer: [],
      allowedFormats: ['ges1p5', 'geslab', 'havas', 'sifac']
    }
  },
  mounted () {
    this.buffer = this.coreStore.setting('travels', 'FILE_FORMATS').value
  }
}
</script>
